import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Style
import styleFn from '../../../../cross.env';

import {
  DateRangePicker,
  SingleDatePicker,
  isInclusivelyBeforeDay,
  isInclusivelyAfterDay,
} from 'react-dates';
import { START_DATE, END_DATE } from 'react-dates/constants';
import isSameDay from 'react-dates/lib/utils/isSameDay';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

// Translation
// import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
// import messages from '../../../locale/messages';

@observer
class DateRange extends React.Component {
  @observable nextBlockedDay = null;
  static propTypes = {
    minimumNights: PropTypes.number.isRequired,
    maximumNights: PropTypes.number.isRequired,
    blockedDates: PropTypes.array.isRequired,
    listId: PropTypes.number,
    formName: PropTypes.string.isRequired,
    maxDaysNotice: PropTypes.number.isRequired,
    // formatMessage: PropTypes.func,
  };

  static defaultProps = {
    blockedDates: [],
    maxDaysNotice: 'unavailable',
  };

  constructor(props) {
    super(props);
    const fI = props.autoOpen
      ? props.autoFocusEndDate
        ? END_DATE
        : START_DATE
      : null;

    const bd = {};
    if (props.blockedDates) {
      props.blockedDates.forEach(
        d => (bd[moment(d).format('YYYY-MM-DD')] = true),
      );
    }

    this.state = {
      focused: fI,
      startDate: props.initialStartDate,
      endDate: props.initialEndDate,
      blockedDates: bd,
      blockedDateMap: bd,
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    // this.isDayBlocked = this.isDayBlocked.bind(this);
  }

  async onDatesChange(date) {
    const { formName, change } = this.props;

    let nextBlockedDay;
    if (date) {
      nextBlockedDay = Object.keys(this.state.blockedDateMap).reduce(
        (prev, next) => {
          if (!isInclusivelyAfterDay(moment(next), date)) {
            return prev;
          } else if (!prev) {
            return next;
          } else if (isInclusivelyBeforeDay(moment(next), moment(prev))) {
            return next;
          }
          return prev;
        },
        null,
      );
      if (nextBlockedDay) {
        nextBlockedDay = moment(nextBlockedDay);
      }
    } else {
      nextBlockedDay = null;
    }
    this.nextBlockedDay = nextBlockedDay;
    this.setState({ startDate: date });
    console.log('Dates changed', formName, 'date: ', date);
    change('startDate', date);
  }

  onFocusChange({ focused }) {
    console.log('focused', focused);
    this.setState({ focused });
  }

  isDayBlocked = day => {
    const dayStr = moment(day).format('YYYY-MM-DD');
    const nextBlockedDay = this.nextBlockedDay;
    if (nextBlockedDay) {
      return (
        this.state.blockedDateMap[dayStr] ||
        isInclusivelyAfterDay(day, nextBlockedDay)
      );
    }
    return this.state.blockedDateMap[dayStr];
  };

  buildCondition = (today, breakpoint) => {
    return day =>
      !isInclusivelyAfterDay(day, today) ||
      isInclusivelyAfterDay(day, breakpoint);
  };

  render() {
    const { focused, startDate, endDate } = this.state;
    const {
      minimumNights,
      maximumNights,
      blockedDates,
      maxDaysNotice,
      keepOpenOnDateSelect,
      openDirection,
      numberOfMonths,
      autoFocus,
      disabled,
    } = this.props;
    const showClearDates = this.props.hasOwnProperty('showClearDates')
      ? this.props.showClearDates
      : true;
    // const { formatMessage } = this.props.intl;
    let condition, maximumEndDate;
    const today = moment();
    let breakPoint;
    if (maxDaysNotice === 'unavailable') {
      condition = this.buildCondition(today, today);
    } else {
      if (maxDaysNotice === '3months') {
        breakPoint = moment().add(3, 'months');
      } else if (maxDaysNotice === '6months') {
        breakPoint = moment().add(6, 'months');
      } else if (maxDaysNotice === '9months') {
        breakPoint = moment().add(9, 'months');
      } else if (maxDaysNotice === '12months') {
        breakPoint = moment().add(12, 'months');
      }
      if (maxDaysNotice !== 'available') {
        condition = this.buildCondition(today, breakPoint);
      }
    }

    return (
      <div>
        <SingleDatePicker
          onDateChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focused={focused}
          date={startDate}
          numberOfMonths={numberOfMonths}
          placeholder="mm/dd/yyyy"
          isOutsideRange={condition}
          hideKeyboardShortcutsPanel
          keepOpenOnDateSelect={keepOpenOnDateSelect || false}
          openDirection={openDirection || 'down'}
          isDayBlocked={this.isDayBlocked}
          disabled={disabled}
          showClearDate
        />
      </div>
    );
  }
}

export default styleFn(DateRange);



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/DateRange/DateRange.js